import { render } from "./BgBlobs.vue?vue&type=template&id=33b38f1e&ts=true"
import script from "./BgBlobs.vue?vue&type=script&lang=ts"
export * from "./BgBlobs.vue?vue&type=script&lang=ts"

import "./BgBlobs.vue?vue&type=style&index=0&id=33b38f1e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__